(function() {
    var menuCookieName = "showMenu";
    function toggleMenu() {
        $(".nav_lvl1_row, .top_menu, .nav_lvl3").toggleClass("showMenu");
        $.cookie(menuCookieName, $(".nav_lvl1_row, .top_menu, .nav_lvl3").hasClass("showMenu") ? "1" : "0", { expires: 7 });
    }

    $(document).ready(function() {
        $('.mobile-menu').click(toggleMenu);
    });
}());